// extracted by mini-css-extract-plugin
module.exports = {"Sticker":"Sticker__Sticker___eytxC","StickerBlue":"Sticker__StickerBlue___2QOJu","StickerGreen":"Sticker__StickerGreen___zWgzq","StickerGrey":"Sticker__StickerGrey___31SDS"};